'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = undefined;

var _styledComponents = require('styled-components');

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _misc = require('../utils/misc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateMediaQueryArg = function generateMediaQueryArg(name, value, baseDivider) {
  if (!(0, _misc.isValidPositiveNumberOrZero)(baseDivider) || !baseDivider) throw new Error('Invalid \'baseDivider\' value: ' + baseDivider);
  if (!(0, _misc.isUndef)(value)) {
    if (typeof value === 'string') return '(' + name + ': ' + value + ')';else if ((0, _misc.isValidPositiveNumberOrZero)(value)) return '(' + name + ': ' + value / baseDivider + 'em)';else throw new Error('Invalid media query \'' + name + '\' value: ' + value);
  } else {
    return void 0;
  }
};

/**
 * MEDIA QUERIES
 * iterate through the sizes and create a media template
 */
var media = exports.media = function media(fromWidth, untilWidth) {
  var baseDivider = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _base2.default.breakpointsEmBase;
  return function () {
    var argNames = ['min-width', 'max-width'];

    var query = [fromWidth, untilWidth].map(function (value, index) {
      return generateMediaQueryArg(argNames[index], value, baseDivider);
    }).filter(Boolean).join(' and ');

    return query.length ? (0, _styledComponents.css)(['@media ', '{', '}'], query, _styledComponents.css.apply(undefined, arguments)) : null;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-core/dist/mixins/media.js
// module id = 628
// module chunks = 0